/**
 * @generated SignedSource<<586f6797b9a759d1e6e4326f6536fb02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UniversalLinkCard_brand$data = {
  readonly appConfig: {
    readonly androidAppLinksEnabled: boolean;
    readonly id: string;
    readonly iosUniversalLinksEnabled: boolean;
  };
  readonly " $fragmentType": "UniversalLinkCard_brand";
};
export type UniversalLinkCard_brand$key = {
  readonly " $data"?: UniversalLinkCard_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"UniversalLinkCard_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UniversalLinkCard_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iosUniversalLinksEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "androidAppLinksEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "326d6e07d203de6e52a7cb64ea689823";

export default node;
